import authService from './authService';
import apiClient from './apiClient';

function getAuthHeader() {
  const token = authService.getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function handleAdminError(error) {
  if (error.response?.status === 401) {
    authService.logout();
    authService.redirectToMicrosoftLogin();
    throw new Error('Session expired. Please login again.');
  }
  if (error.response?.status === 403) {
    window.location.href = '/forbidden';
    throw new Error('Access denied');
  }
  throw error;
}

class AdminService {
  async getStats() {
    try {
      const res = await apiClient.get('/admin/stats', { headers: getAuthHeader() });
      return res.data;
    } catch (e) {
      handleAdminError(e);
    }
  }

  async listUsers() {
    try {
      const res = await apiClient.get('/admin/users', { headers: getAuthHeader() });
      return res.data;
    } catch (e) {
      handleAdminError(e);
    }
  }

  async exportResultsCsv() {
    try {
      const res = await apiClient.get('/admin/export/results.csv', { headers: getAuthHeader() });
      return res.data;
    } catch (e) {
      handleAdminError(e);
    }
  }

  async allowRetake(email) {
    try {
      const res = await apiClient.post(`/admin/users/${encodeURIComponent(email)}/retake`, null, { headers: getAuthHeader() });
      return res.data;
    } catch (e) {
      handleAdminError(e);
    }
  }

}

export default new AdminService();
